/**
 * Die Abschluss-Karte als Element. (Ticket 2444)
 *
 * Dieselben Klassen wie jede Werkzeug-Karte (`tool-card`, `tool-actions`,
 * `tool-action-btn`) — kein eigener Stil, nur eine Kennung dazu.
 */
import type { IconName } from "./icons.js";
import { aktionsKnopf, aktionsLeiste, baueKarte } from "./karte.js";
import { ohneDoppelte, type Ergebnis } from "./abschluss.js";
import { istPdfAdresse, oeffnePdf } from "./pdf-schau.js";

function knopf(label: string, symbol: IconName, onClick: () => void): HTMLButtonElement {
  return aktionsKnopf({ text: label, primaer: true, symbol, onClick }) as HTMLButtonElement;
}

async function kopiere(text: string, b: HTMLButtonElement): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    b.lastChild!.textContent = " Kopiert";
  } catch {
    b.lastChild!.textContent = " Kopieren ging nicht";
  }
}

export function baueAbschlussKarte(roh: readonly Ergebnis[]): HTMLElement {
  const ergebnisse = ohneDoppelte(roh);
  const el = baueKarte("abschluss", ergebnisse.length === 1 ? "Fertig — dein Ergebnis" : `Fertig — ${ergebnisse.length} Ergebnisse`);
  el.classList.add("tool-card--abschluss");
  el.dataset.tool = "abschluss";
  for (const e of ergebnisse) {
    const zeile = aktionsLeiste(el);
    if (e.art === "datei") {
      zeile.appendChild(
        knopf(e.titel, "link", () => {
          void import("./project-file-viewer.js").then(({ openProjectFileViewer }) =>
            openProjectFileViewer(e.projectId, e.fileId, {}),
          );
        }),
      );
    } else if (e.art === "link") {
      zeile.appendChild(
        aktionsKnopf({
          text: e.titel,
          primaer: true,
          symbol: "download",
          href: e.url,
          neuesFenster: true,
          // Dieselbe PDF-Frage wie überall (pdf-schau.ts), nicht eine eigene Fassung.
          onClick: istPdfAdresse(e.url)
            ? (ev) => {
                ev.preventDefault();
                oeffnePdf(e.url, e.titel);
              }
            : undefined,
        }),
      );
    } else {
      const b = knopf(`${e.titel} kopieren`, "check", () => void kopiere(e.text, b));
      zeile.appendChild(b);
    }
  }
  return el;
}
